import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ContactRequest } from '../models/contact.interface';


@Injectable({
  providedIn: 'root',
})
export class Contact {

  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/contact`;

  sendContact(data: ContactRequest) {

    return this.http.post(this.apiUrl, data);

  }
}
